import useRmas from '@/lib/hook/useRmas'

/**
 * Nombre de litiges en attente d'action du client (resolus A/Q, responsible_actor='customer').
 * Reutilise la liste rma (action 21) deja exposee par PharmeRma : pas d'endpoint dedie.
 * items_per_page eleve car un client a peu de litiges.
 */
const useDisputeActionCount = (enabled = true): number => {
  const { data } = useRmas({ action: 21, items_per_page: 200, enabled })

  if (!data?.rmas) {
    return 0
  }

  return data.rmas.filter(rma => rma.responsible_actor === 'customer').length
}

export default useDisputeActionCount
